import { useState, useCallback, useMemo } from 'react';
import ReactPlayer from 'react-player/lazy'
import SNSImg from '../image/sns.png';
import QRCodeImg from '../image/artly-qr-code-frame.png';
// import PromotionImg from '../image/free-toppings.png';

import {
    VIDEO_BACKGROUND_COLOR,
    LANDSCAPE_VIDEO_ASPECT_RATIO,
    PORTRAIT_VIDEO_ASPECT_RATIO,
} from '../constant';
import { useStoreConfig } from './hooks';

/*
 Display the promotion image only at Hill7 location. 
 This is a magic number check which is not technically great. 
 But we'll not implement it in an elegant way for now.
*/
function getRightBottomImageUrl(storeId) {
    return QRCodeImg;
}

function Overlays(props) {
    const {
        storeId,
        landscapeFlag,
        screenWidth,
        screenHeight,
        needAttachedLogos = [],
        needAttachedQrcode = false,
        needAttachedSns = false,
    } = props;

    const style = useMemo(() => {
        const ratio = landscapeFlag ? LANDSCAPE_VIDEO_ASPECT_RATIO : PORTRAIT_VIDEO_ASPECT_RATIO;
        if ((screenWidth / screenHeight) < ratio) { // full-width
            const value = (screenHeight - (screenWidth / ratio)) / 2;
            return {
                top: `${value}px`,
                left: 0,
                height: `${screenHeight - value * 2}px`,
                width: '100vw',
            };
        }
        const value = (screenWidth - (screenHeight * ratio)) / 2;
        return {
            left: `${value}px`,
            top: 0,
            width: `${screenWidth - value * 2}px`,
            height: '100vh',
        };
    }, [screenWidth, screenHeight, landscapeFlag]);

    const extraClassName = landscapeFlag ? 'horz' : 'vert';
    return (
        <div className={`overlays ${extraClassName}`} style={style}>
            {(needAttachedLogos && needAttachedLogos.length > 0) && (
                <div className="logos">
                    {needAttachedLogos.map(url => <img key={url} className="logo" src={url} alt="logo" />)}
                </div>
            )}
            {needAttachedSns && <img className="sns" src={SNSImg} alt="sns" />}
            {needAttachedQrcode && <img className="qrcode" src={getRightBottomImageUrl(storeId)} alt="qrcode" />}
        </div>
    );
}

export default function VideoPlayer(props) {
    const { storeId, landscapeFlag, screenWidth, screenHeight } = props;
    const [isFallback, setIsFallback] = useState(false);
    const storeConfig = useStoreConfig({ storeId });

    const onError = useCallback(() => {
        setIsFallback(true);
    }, [setIsFallback]);

    // PLEASE GO TO constant.js TO CHANGE VIDEO URLS, NOT HERE.
    const deviceVideo = landscapeFlag
        ? storeConfig.landscapeVideo
        : storeConfig.portraitVideo;
    const fallbackVideo = landscapeFlag
        ? storeConfig.landscapeFallbackVideo
        : storeConfig.portraitFallbackVideo;
    const videoInfo = isFallback ? fallbackVideo : deviceVideo;
    const { url: videoUrl, needAttachedLogos, needAttachedSns, needAttachedQrcode } = videoInfo;
    return (
        <>
            <Overlays
                storeId={storeId}
                landscapeFlag={landscapeFlag}
                screenWidth={screenWidth}
                screenHeight={screenHeight}
                needAttachedLogos={needAttachedLogos}
                needAttachedSns={needAttachedSns}
                needAttachedQrcode={needAttachedQrcode}
            />
            <ReactPlayer
                url={videoUrl}
                width="100vw"
                height="100vh"
                style={{ backgroundColor: VIDEO_BACKGROUND_COLOR }}
                loop
                muted
                playing
                onError={onError}
            />
        </>
    );

}
